import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 20px 15px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  align-self: flex-end;
`;
